import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import GallectionTiptapEditor from '@wix/da-editor-tiptap/pkg/components/Editor/presets/Gallection';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import { EditorContextProviderWrapper } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';
import useEditorNg from '../DaEditorNg/hooks/useEditorNg';
import EditorCommon from '../DaEditorNg/EditorCommon';
const GallectionEditor = ({ onChange, onInitialContentReady, initialContent, compact })=>{
    const { editorProps, editorSharedProps, editorCommonProps } = useEditorNg({
        onEditorChange: onChange,
        onEditorReady: (api)=>{
            onInitialContentReady && onInitialContentReady(api);
        }
    });
    return /*#__PURE__*/ React.createElement(EditorContextProviderWrapper, null, /*#__PURE__*/ React.createElement(EditorCommon, editorCommonProps), /*#__PURE__*/ React.createElement(GallectionTiptapEditor, _object_spread_props(_object_spread({
        cookieType: MeasuredCookieType.GALLECTION_FOLDER
    }, editorSharedProps, editorProps), {
        initialContent: initialContent,
        compact: compact
    })));
};
GallectionEditor.displayName = 'GallectionEditor';
export default GallectionEditor;

//# sourceMappingURL=GallectionEditor.js.map